import { IDescribeCase, TypesDescribe } from "@context/types/describeCase.ts";
import { GlobalAction } from "@context/types";

export const describeReducer = (state: IDescribeCase, action: GlobalAction) => {
  switch (action.type) {
    case TypesDescribe.Finish:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
